

























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { BPagination, BSpinner, VBPopover, BButton, VBTooltip } from 'bootstrap-vue';
import { PaginatedList } from '@/api/models/common/paginatedList';
import { ActionMilieuTravailList } from '@/api/models/actionsMilieuTravail/actionMilieuTravail';
import { successAlert } from "@/libs/sweetAlerts/alerts";
import { DroitsEnum } from "@/api/models/enums/droitsEnum";
import DeleteIcon from '@/components/icons/DeleteIcon.vue'
import EditIcon from '@/components/icons/EditIcon.vue'
import { TypeCodeActionMilieuTravail } from '@/api/models/actionsMilieuTravail/typeActionMilieuTravail';

@Component({
  name: 'list-actions-milieu-travail',
  components: {
    BPagination,
    BSpinner,
    BButton,
    DeleteIcon,
    EditIcon
  },
  directives: {
    'b-popover': VBPopover,
    'b-tooltip': VBTooltip,
  }
})
export default class ListActionsMilieuTravail extends Vue {
  droitsEnum = DroitsEnum;
  typeCodeActionMilieuTravail = TypeCodeActionMilieuTravail;

  currentPage = 1;
  perPage = 5;

  paginatedList : PaginatedList<ActionMilieuTravailList> = new PaginatedList<ActionMilieuTravailList>()

  listLoading = true

  async created() {
    await this.loadActions();
  }

  @Watch('currentPage')
  async currentPageChange(){
    await this.loadActions()
  }

  async loadActions(siteId?: string) {
    this.listLoading = true;
    
    await this.$http.ressifnet.actionsMilieuTravail
      .paginatedList(this.$route.params.idEntreprise, siteId, this.currentPage, this.perPage)
      .then(
        (res: PaginatedList<ActionMilieuTravailList>) => {
          this.paginatedList = res;
          this.listLoading = false
        })
  }

  async deleteAction(id: string) {
    this.$bvModal
        .msgBoxConfirm('Etes-vous sûr de vouloir supprimer l\'action ?', {
          title: 'Confirmation de suppression',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Oui',
          cancelTitle: 'Non',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(async value => {
          if(value === true){
            await this.confirmDeleteAction(id)
          } 
          else {
            return
          }
        })
  }

  async confirmDeleteAction(id: string) {
    await this.$http.ressifnet.actionsMilieuTravail
      .delete(this.$route.params.idEntreprise, id)
      .then(
        (res: any) => {
          successAlert.fire({
            title: "Suppression d'une action",
            text: "Suppression effectuée avec succès",
          });
          this.loadActions()
          this.$emit('reset-form')
        }
      )
  }

  async selectAction(id: string, mode:string) {
    this.$emit('select-action', id,mode)
  }
}
